export default __webpack_public_path__ + "static/media/belt_of_the_whispering_blade.273ba883.jpg";